<div class="modal-content p-4">
  <div class="row">
    <div class="col-sm-12">
      <button class="close mr-4 mt-2" type="button" (click)="close()"><i class="fa fa-times"></i></button>
    </div>
  </div>

  <div class="modal-header my-3 px-3">
    <h4>Agregar/Eliminar Entidades Derivadas</h4>
  </div>

  <div class="row">
    <div class="col-12">
      <app-alert-message *ngFor="let message of messages; let i = index"
        [message]="message.text"
        [isError]="message.isError"
        [isSuccess]="message.isSuccess"
        (close)="removeMessage(i)"
      ></app-alert-message>
    </div>
  </div>

  <div class="modal-body px-5">

    <div class="col-12 text-center">
      <div class="ml-2 mb-3">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn btn-outline-primary" [ngClass]="{'active': mostrarFormulario}" (click)="resetToAgregar()">
            <input type="radio" name="options" id="option1" autocomplete="off" checked> 
            Agregar
          </label>
          <label class="btn btn-outline-primary" [ngClass]="{'active': !mostrarFormulario}" (click)="resetToEliminar()">
            <input type="radio" name="options" id="option2" autocomplete="off"> 
            Eliminar
          </label>
        </div>
      </div>
    </div>

    <ng-container *ngIf="mostrarFormulario">
      <div class="row" style="max-height: 400px !important; overflow-y: auto;">
        <div class="col-sm-12 mx-auto">
          <div class="row px-5">
            <div class="col-sm-12">
              <h4>Seleccione entidad a agregar</h4>
            </div>
            <div class="col-sm-12 d-flex align-items-center"> 
    
              <select class="form-control text-capitalize" [(ngModel)]="entidadSeleccionada" style="max-width: 200px;">
                <option value="">Seleccione...</option>
                <ng-container *ngFor="let entidad of entidadesSeleccionables;">
                    <option [value]="entidad.key" class="text-capitalize">
                        {{entidad.name}}
                    </option>
                </ng-container>
              </select>
              
              <button type="button" class="btn btn-success btn-mas ml-2 ms-2" (click)="agregarEntidadForm()">
                <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
  
            </div>
          </div>
        </div>
        <div class="col-sm-12 mx-auto mt-3" *ngIf="formComponent && formComponent.length > 0">
          <div class="row">
            <div class="col-sm-12 col-md-6 my-2" *ngFor="let item of formComponent; let indexItem = index">
              <div class="card">
                <div class="card-body">
                  <div class="col-sm-12">
                    <button type="button" class="btn btn-danger btn-mas float-right mb-2" (click)="eliminarEntidad(indexItem)">
                      <i class="fa fa-minus" aria-hidden="true"></i>
                    </button>
                  </div>
                  <h4 class="card-title text-center">{{item?.entidad || ''}}</h4>
                  <ng-container *ngIf="item?.outputVars && item.outputVars.length > 0">
                    <form [formGroup]="item.form" class="row">
                      <ng-container *ngFor="let atributo of item?.outputVars, let j = index">

                        <div class="form-group col-sm-12" *ngIf="atributo.name.toUpperCase() === 'RUT'">
                          <label>{{atributo.displayName}}</label>
                          <input type="text" class="form-control"
                            formatRut required formControlName="rut">
                            <div class="w-100">
                              <span *ngIf="item.form.get('rut')?.value && item.form.get('rut')?.hasError('rutValidate')" class="text-danger font-weight-bolder">* Rut no valido</span>
                            </div>
                        </div>

                        <div class="form-group col-sm-12" *ngIf="atributo.name.toUpperCase() !== 'RUT' && (atributo.typeAttribute === 'String' || atributo.typeAttribute === 'Number' || atributo.typeAttribute === 'Password')">
                          <label>{{atributo.displayName}}</label>
                          <input type="{{atributo.typeAttribute === 'String' ? 'text' : atributo.typeAttribute}}" class="form-control"
                            formControlName="{{atributo.name}}" required>
                            <div class="w-100">
                              <app-error [control]="item.form.get(atributo.name)"></app-error>
                            </div>
                        </div>

                        <div class="form-group col-sm-12" *ngIf="atributo.name.toUpperCase() !== 'RUT' && atributo.typeAttribute === 'Date'">
                          <label>{{atributo.displayName}}</label>
                          <input type="date" class="form-control" formControlName="{{atributo.name}}" required>
                          <div class="w-100">
                            <app-error [control]="item.form.get(atributo.name)"></app-error>
                          </div>
                        </div>

                      </ng-container>
                    </form>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!mostrarFormulario">
      <div class="row" style="max-height: 420px !important; overflow-y: auto; max-width: 500px !important;">
        <div class="col-sm-12 mx-auto my-3" *ngFor="let item of eliminables">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{item?.entidad || item?.entidadId}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-sm-12 col-md-10 mx-auto mb-2"> 
                  <div class="input-group">
                    <input type="text" 
                      class="form-control" 
                      placeholder="Buscar rut en tabla..." 
                      [(ngModel)]="item.searchTerm"
                      (ngModelChange)="filtrarRut(item, item.searchTerm)"
                    >
                    <div class="input-group-append">
                      <span class="input-group-text bg-white text-muted">
                        <i class="fa fa-search"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <ul class="list-group">
                    <ng-container *ngIf="item?.rutsVisibles && item.rutsVisibles.length > 0; else noRuts">
                      <ng-container *ngFor="let itemRut of item.rutsVisibles | paginate: { 
                          id: item.entidadId, 
                          itemsPerPage: 5, 
                          currentPage: item.pagina 
                        }"
                      >
                        <li class="list-group-item d-flex align-items-center justify-content-between">
                          <span class="material-icons mx-2">{{itemRut?.isNatural ? 'person_pin' : 'corporate_fare'}}</span>
                          {{itemRut.rut | rutFormat}}
                          <label class="switch switch-primary switch-sm">
                            <input type="checkbox" class="checkbox-seleccionar mx-2"
                              [(ngModel)]="itemRut.seleccionado"
                            >
                            <span></span>
                          </label>
                        </li>
                      </ng-container>
                      <div class="row mt-2">
                        <div class="col-sm-12 d-flex justify-content-end">
                          <pagination-controls 
                            [id]="item.entidadId"
                            (pageChange)="item.pagina = $event"
                            previousLabel="Anterior"
                            nextLabel="Siguiente">
                          </pagination-controls>
                        </div>
                    </div>
                    </ng-container>
                    <ng-template #noRuts>
                      <li class="list-group-item">No se encontraron ruts</li>
                    </ng-template>
                  </ul>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </ng-container>

    <div class="col-12 text-center my-3">
      <button type="button" class="btn btn-primary" *ngIf="!mostrarFormulario" (click)="eliminar()">Guardar</button>
      <button type="button" class="btn btn-primary" *ngIf="mostrarFormulario && formComponent.length > 0" (click)="agregar()">Guardar</button>
    </div>

  </div>

</div>
